import React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import Icon from '@mui/material/Icon';
import Divider from '@mui/material/Divider';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function EmptyCellActionSheet({ open, onClose, onAdd, onCopy, title, slot }) {
  const handleAdd = () => {
    onAdd?.();
    onClose?.();
  };

  const handleCopy = () => {
    onCopy?.(slot); // ✅ hedef slot'u gönder
    onClose?.();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      TransitionComponent={Transition}
      keepMounted
      disableScrollLock
      aria-labelledby="empty-cell-actions-title"
      aria-describedby="empty-cell-actions-desc"
      PaperProps={{
        sx: (theme) => ({
          borderRadius: '22px',
          overflow: 'hidden',
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: '0 22px 60px rgba(0,0,0,.22), 0 8px 22px rgba(0,0,0,.18)',
          backgroundImage: 'none',
        }),
      }}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0,0,0,.55)',
          backdropFilter: 'blur(6px)',
        },
      }}
    >
      {/* Header */}
      <MDBox
        sx={(theme) => ({
          p: 2.25,
          pb: 2,
          display: 'flex',
          gap: 1.5,
          alignItems: 'center',
          background:
            theme.palette.mode === 'dark'
              ? 'linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,0))'
              : 'linear-gradient(180deg, rgba(0,0,0,.04), rgba(0,0,0,0))',
        })}
      >
        <MDBox
          sx={(theme) => ({
            width: 42,
            height: 42,
            borderRadius: '14px',
            display: 'grid',
            placeItems: 'center',
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor:
              theme.palette.mode === 'dark' ? 'rgba(255,255,255,.06)' : 'rgba(0,0,0,.03)',
          })}
        >
          <Icon sx={{ fontSize: 20, opacity: 0.9 }}>bolt</Icon>
        </MDBox>

        <MDBox sx={{ minWidth: 0 }}>
          <MDTypography
            id="empty-cell-actions-title"
            variant="button"
            fontWeight="bold"
            sx={{ display: 'block', lineHeight: 1.2 }}
          >
            {title || 'Boş slot'}
          </MDTypography>
          <MDTypography
            id="empty-cell-actions-desc"
            variant="caption"
            sx={{ opacity: 0.75, display: 'block', mt: 0.35 }}
          >
            Bu alana hızlıca işlem seç.
          </MDTypography>
        </MDBox>
      </MDBox>

      <Divider />

      {/* Actions */}
      <MDBox sx={{ p: 2.25, display: 'grid', gap: 1.1 }}>
        <MDButton
          variant="gradient"
          color="info"
          fullWidth
          startIcon={<Icon sx={{ fontSize: 20 }}>add</Icon>}
          onClick={handleAdd}
          sx={(theme) => ({
            borderRadius: '16px',
            textTransform: 'none',
            fontWeight: 800,
            height: 46,
            boxShadow:
              theme.palette.mode === 'dark'
                ? '0 10px 24px rgba(0,0,0,.35)'
                : '0 10px 24px rgba(0,0,0,.18)',
            '&:focus-visible': {
              outline: 'none',
              boxShadow: '0 0 0 3px rgba(29, 233, 182, .25), 0 10px 24px rgba(0,0,0,.18)',
            },
          })}
        >
          Seans ekle
        </MDButton>

        <MDButton
          variant="outlined"
          color="dark"
          fullWidth
          startIcon={<Icon sx={{ fontSize: 20 }}>content_copy</Icon>}
          onClick={handleCopy}
          sx={(theme) => ({
            borderRadius: '16px',
            textTransform: 'none',
            fontWeight: 800,
            height: 46,
            borderWidth: '1.5px',
            '&:hover': {
              borderWidth: '1.5px',
              backgroundColor:
                theme.palette.mode === 'dark' ? 'rgba(255,255,255,.06)' : 'rgba(0,0,0,.03)',
            },
            '&:focus-visible': {
              outline: 'none',
              boxShadow: '0 0 0 3px rgba(0,0,0,.12)',
            },
          })}
        >
          Seans kopyala
        </MDButton>

        <MDButton
          variant="text"
          color="secondary"
          fullWidth
          onClick={onClose}
          sx={(theme) => ({
            borderRadius: '16px',
            textTransform: 'none',
            fontWeight: 800,
            height: 42,
            opacity: 0.9,
            '&:hover': {
              backgroundColor:
                theme.palette.mode === 'dark' ? 'rgba(255,255,255,.06)' : 'rgba(0,0,0,.03)',
            },
          })}
        >
          Kapat
        </MDButton>
      </MDBox>

      {/* tiny bottom safe area */}
      <MDBox sx={{ height: 6 }} />
    </Dialog>
  );
}
